import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styles from './table.module.css';
import TableSkeleton from "./TableSkeleton";
import { useRouter } from "next/router";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { getFilterCount, getFilteredData, getHomeTableData, getTopUsers, getTopUsersFilters } from "../../../api/requests";
import { kFormatter } from "../../../utils";
import Slider from "./filterCarousel/Slider";
import { loadGetInitialProps } from "next/dist/next-server/lib/utils";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

var Table = function Table() {
  var router = useRouter();

  var _useState = useState(null),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = useState(null),
      filters = _useState2[0],
      setFilters = _useState2[1];

  var _useState3 = useState(null),
      tableData = _useState3[0],
      setTableData = _useState3[1];

  var _useState4 = useState(false),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(false),
      dropdownOpen = _useState5[0],
      setDropdownOpen = _useState5[1];

  var _useState6 = useState(null),
      selectedItem = _useState6[0],
      setSelectedItem = _useState6[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';

  var toggle = function toggle(item) {
    return setDropdownOpen(function (prevState) {
      return !prevState;
    });
  };

  var handleSelect = function handleSelect(selected) {
    setLoading(true);
    setSelectedItem({
      Title: selected.Title,
      Count: selected.Count
    });
    getTopUsers(selected.Id, 0).then(function (res) {
      var _res$data, _res$data2;

      setLoading(false);
      setData((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.Users);
      setTableData((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.Users.slice(0, 5));
    })["catch"](function (err) {
      return console.log(err);
    });
  };

  useEffect(function () {
    setLoading(true); //get filters

    getTopUsersFilters(isRTL).then(function (res) {
      setFilters(res.data);
      var defaultSelect = res.data.filter(function (item) {
        return item.Id === 2;
      });

      if (defaultSelect.length > 0) {
        setSelectedItem(defaultSelect[0]); //get data based on filter

        getTopUsers(defaultSelect[0].Id, 0).then(function (res) {
          var _res$data3, _res$data4;

          setLoading(false);
          setData((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.Users);
          setTableData((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.Users.slice(0, 5));
        })["catch"](function (err) {
          return console.log(err);
        });
      }
    })["catch"](function (err) {
      return console.log(err);
    });
  }, [isRTL]);

  var showMore = function showMore() {
    if (tableData.length === data.length) {
      router.push("/top-users");
    } else {
      setTableData(data);
    }
  };

  var sliderSetting = {
    className: styles.slider,
    items: filters
  };

  var getProfieImageSrc = function getProfieImageSrc(item) {
    if (item && item.ProfileImage && item.ProfileImage === 'img/head.png') {
      return '/images/table/profile.png';
    } else if (item && item.ProfileImage && item.ProfileImage !== " ") {
      return item.ProfileImage;
    } else {
      return '/images/table/profile.png';
    }
  };

  var getFilterNameFa = function getFilterNameFa(filterEn) {
    switch (filterEn) {
      case 'Today':
        return 'امروز';

      case 'Overall':
        return 'کلی';

      case 'This Week':
        return 'این هفته';

      case 'This Month':
        return 'این ماه';

      case 'Elementary':
        return 'ابتدایی';

      case '7th grade':
        return 'کلاس هفتم';

      case '8th grade':
        return 'کلاس هشتم';

      case '9th grade':
        return 'کلاس نهم';

      case '10th grade':
        return 'کلاس دهم';

      case '11th grade':
        return 'کلاس یازدهم';

      case '12th grade':
        return 'کلاس دوازدهم';

      case 'Advanced':
        return 'پیشرفته';
    }
  };

  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("div", {
      className: "home-table ".concat(styles.wrapper),
      children: [data && /*#__PURE__*/_jsxs(Dropdown, {
        className: styles.dropDown,
        isOpen: dropdownOpen,
        toggle: toggle,
        children: [/*#__PURE__*/_jsxs(DropdownToggle, {
          caret: true,
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.boldTxt,
            children: selectedItem.Title
          }), " ", /*#__PURE__*/_jsx("span", {
            className: styles.boldTxt,
            children: selectedItem.Count
          }), /*#__PURE__*/_jsx("img", {
            className: styles.arrowDown,
            src: "images/table/arrowDown.svg"
          })]
        }), /*#__PURE__*/_jsxs(DropdownMenu, {
          children: [console.log("filters", filters), data && filters && filters.map(function (item) {
            return /*#__PURE__*/_jsxs(DropdownItem, {
              onClick: function onClick() {
                return handleSelect(item);
              },
              className: styles.dropDownItem,
              children: [/*#__PURE__*/_jsx("p", {
                children: item.Title
              }), /*#__PURE__*/_jsx("pre", {
                children: ': '
              }), /*#__PURE__*/_jsx("p", {
                children: item.Count
              }), /*#__PURE__*/_jsx("img", {
                className: "".concat(styles.userIcon),
                src: "/images/table/profile.png"
              })]
            }, item.Id);
          })]
        })]
      }), loading && /*#__PURE__*/_jsx(TableSkeleton, {}), !loading && /*#__PURE__*/_jsx(Slider, {
        getFilterNameFa: getFilterNameFa,
        isRTL: isRTL,
        selectedItem: selectedItem,
        setting: sliderSetting,
        onItemSelect: handleSelect
      }), !loading && data && /*#__PURE__*/_jsxs("div", {
        className: "w-100",
        children: [/*#__PURE__*/_jsxs("table", {
          className: "table table-striped mt-4 ".concat(isRTL ? [styles.tableFa, styles.table].join(" ") : styles.table),
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsxs("tr", {
              className: styles.borderNone,
              children: [/*#__PURE__*/_jsxs("th", {
                className: styles.header,
                scope: "col",
                children: ["#", /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                scope: "col",
                children: [t('home:Name'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                scope: "col",
                children: [t('home:Score'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                scope: "col",
                children: [t('home:Grade'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                scope: "col",
                children: [t('home:Words'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                className: "".concat(styles.desktopOnlyColumn, " ").concat(styles.daysPlayed),
                scope: "col",
                children: [t('home:Days played'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                className: "".concat(styles.desktopOnlyColumn),
                scope: "col",
                children: [t('home:City'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              }), /*#__PURE__*/_jsxs("th", {
                className: "".concat(styles.desktopOnlyColumn),
                scope: "col",
                children: [t('home:Awards'), /*#__PURE__*/_jsx("div", {
                  className: styles.header
                })]
              })]
            })
          }), /*#__PURE__*/_jsx("tbody", {
            children: tableData && tableData.map(function (item, index) {
              var _item$ContestProfile, _item$ContestProfile2, _item$ContestProfile3, _item$ContestProfile4, _item$ContestProfile5, _item$ContestProfile6, _item$ContestProfile7, _item$ContestProfile8, _item$ContestProfile9;

              return /*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: "/profile/".concat(item.Counter),
                  query: {
                    name: item.FullName
                  }
                },
                children: /*#__PURE__*/_jsxs("tr", {
                  className: styles.row,
                  children: [/*#__PURE__*/_jsx("th", {
                    className: styles.index,
                    scope: "row",
                    children: /*#__PURE__*/_jsxs("div", {
                      className: "btn d-flex justify-content-around align-items-center",
                      children: [/*#__PURE__*/_jsxs("span", {
                        children: [index + 1, '.', " "]
                      }), /*#__PURE__*/_jsx("img", {
                        className: "".concat(styles.icon),
                        src: getProfieImageSrc(item)
                      })]
                    })
                  }), /*#__PURE__*/_jsx("td", {
                    children: item.FullName
                  }), /*#__PURE__*/_jsx("td", {
                    children: kFormatter((_item$ContestProfile = item.ContestProfile) === null || _item$ContestProfile === void 0 ? void 0 : _item$ContestProfile.TotalReputation)
                  }), /*#__PURE__*/_jsx("td", {
                    children: (_item$ContestProfile2 = item.ContestProfile) !== null && _item$ContestProfile2 !== void 0 && _item$ContestProfile2.MappedGroupCode ? ((_item$ContestProfile3 = item.ContestProfile) === null || _item$ContestProfile3 === void 0 ? void 0 : _item$ContestProfile3.MappedGroupCode) + 'th' : '-'
                  }), /*#__PURE__*/_jsx("td", {
                    children: (_item$ContestProfile4 = item.ContestProfile) === null || _item$ContestProfile4 === void 0 ? void 0 : _item$ContestProfile4.WoW
                  }), /*#__PURE__*/_jsx("td", {
                    className: "".concat(styles.desktopOnlyColumn),
                    children: (_item$ContestProfile5 = item.ContestProfile) === null || _item$ContestProfile5 === void 0 ? void 0 : _item$ContestProfile5.DaysPlayed
                  }), /*#__PURE__*/_jsx("td", {
                    className: "".concat(styles.desktopOnlyColumn),
                    children: item.State
                  }), /*#__PURE__*/_jsx("td", {
                    className: "".concat(styles.desktopOnlyColumn),
                    children: /*#__PURE__*/_jsxs("div", {
                      className: "d-flex justify-content-around",
                      children: [/*#__PURE__*/_jsxs("div", {
                        className: "d-flex justify-content-between align-items-center ".concat(styles.medalCell),
                        children: [/*#__PURE__*/_jsx("img", {
                          className: "m-1",
                          src: "/images/table/bronzeBadge.svg"
                        }), /*#__PURE__*/_jsx("span", {
                          children: (_item$ContestProfile6 = item.ContestProfile) === null || _item$ContestProfile6 === void 0 ? void 0 : _item$ContestProfile6.TotalBronzeBadges
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "d-flex justify-content-between align-items-center ".concat(styles.medalCell),
                        children: [/*#__PURE__*/_jsx("img", {
                          className: "m-1",
                          src: "/images/table/silverBadge.svg"
                        }), /*#__PURE__*/_jsx("span", {
                          children: (_item$ContestProfile7 = item.ContestProfile) === null || _item$ContestProfile7 === void 0 ? void 0 : _item$ContestProfile7.TotalSilverBadges
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "d-flex justify-content-between align-items-center ".concat(styles.medalCell),
                        children: [/*#__PURE__*/_jsx("img", {
                          className: "m-1",
                          src: "/images/table/goldBadge.svg"
                        }), /*#__PURE__*/_jsx("span", {
                          children: (_item$ContestProfile8 = item.ContestProfile) === null || _item$ContestProfile8 === void 0 ? void 0 : _item$ContestProfile8.TotalGoldBadges
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "d-flex justify-content-between align-items-center ".concat(isRTL ? styles.paddingLeft : styles.paddingRight),
                        children: [/*#__PURE__*/_jsx("img", {
                          className: "m-1",
                          src: "/images/table/diamondBadge.svg"
                        }), /*#__PURE__*/_jsx("span", {
                          children: (_item$ContestProfile9 = item.ContestProfile) === null || _item$ContestProfile9 === void 0 ? void 0 : _item$ContestProfile9.DiamondBadges
                        })]
                      })]
                    })
                  })]
                })
              }, index);
            })
          })]
        }), /*#__PURE__*/_jsxs("h6", {
          onClick: showMore,
          className: [styles.more, isRTL ? styles.textAlignLeft : styles.textAlignRight].join(' '),
          children: [t('home:more'), /*#__PURE__*/_jsx("div", {
            children: "..."
          })]
        })]
      })]
    })
  });
};

export default Table;